import React, { useRef } from "react";
import {
  EmptyModal,
  Table,
  TableWithHeader,
  Select,
} from "../../../../components/core";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useQuery } from "@apollo/client";
import { OverlayPanel } from "primereact/overlaypanel";
import { QUERY_DROP_OFF_STATUS_HISTORY } from "../../../../constants/graphql/drop-off-graphql";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import TotalRecords from "../../../../components/core/total-records";
import { Chip } from "primereact/chip";
import { Card } from "primereact/card";
import { Badge } from "primereact/badge";
import { Tag } from "primereact/tag";

export default function DropoffStatusHistoryModal({
  isOpen,
  onClose,
  limit,
  setLimit,
}) {
  const dropoffHistory = useSelector(
    (state) => state.agentProfile.dropoffHistory
  );
  const [allDropoffHistory] = useLazyQuery(QUERY_DROP_OFF_STATUS_HISTORY);

  const [currentPackageId, setCurrentPackageId] = React.useState([]);
  const [currentPastDropoff, setCurrentPastDropoff] = React.useState([]);
  const overlayRef = useRef(null);
  const pastDay = [
    { value: 10, name: "Last 10 days" },
    { value: 30, name: "Last month" },
    { value: 60, name: "Last 2 months" },
    { value: 100, name: "Last 100 days" },
  ];

  const DropoffHistoryCard = ({ data }) => {
    const rowClassName = (rowData) => {
      console.log({ rowData });
      if (rowData === "Claimed") {
        return "bg-green-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Revoked") {
        return "bg-red-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Removed") {
        return "bg-gray-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Pending" || rowData === "Pending / Overstay") {
        return "bg-yellow-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Take-Back") {
        return "bg-blue-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Revoked") {
        return "bg-red-500 text-center border-0 text-secondary-purpleGray";
      } else if (rowData === "Cancelled") {
        return "bg-amber-500 text-center border-0 text-secondary-purpleGray";
      }
      return "border-0 text-center text-secondary-purpleGray";
    };

    // const header = (

    // );

    return (
      <Card className="mb-3 shadow-2 ">
        <div className="grid grid-cols-12 items-center text-secondary-purpleGray gap-y-2">
          {/* <div className="col-span-12 items-center p-3 text-secondary-purpleGray"> */}
          <span className="col-span-8 font-bold text-lg">{data.waybill}</span>
          <Tag className={`${rowClassName(data.status)} col-span-4`}>
            {data.status}
          </Tag>
          {/* </div> */}

          {/* <div className="flex justify-content-between"> */}
          <span className="col-span-6 font-semibold">Locker Name:</span>
          <span className="col-span-6">{data.locker}</span>
          {/* </div> */}

          {/* <div className="flex justify-content-between"> */}
          <span className="col-span-6 font-semibold">Recipient Mobile:</span>
          <span className="col-span-6">{data.recipient}</span>
          {/* </div> */}

          <span className="col-span-6 font-semibold">Dropoff Date:</span>
          <span className="col-span-6">{data.dropoff}</span>

          <span className="col-span-6 font-semibold">Hours Elapsed:</span>
          <span className="col-span-6">{data.elapsedHrs}</span>
        </div>
      </Card>
    );
  };

  console.log({ dropoffHistory });
  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      className="max-w-[95%] md:w-[1250px] overflow-hidden"
      draggable={false}
      resizable={false}
    >
      <div className="grid grid-cols-12 items-center">
        <div className="col-span-6 md:col-span-2 text-secondary-purpleGray font-semibold">
          Show data for:{" "}
        </div>
        <Select
          className={"col-span-6"}
          items={pastDay}
          value={limit}
          onChange={(event) => {
            setLimit(event.target.value);
            console.log(limit);
          }}
        />
      </div>

      <div className="hidden md:grid w-full">
        <TableWithHeader
          showHeader={false}
          header={[
            { header_name: "Locker Name", key: "locker" },
            { header_name: "Waybill Number", key: "waybill" },
            { header_name: "Recipient", key: "recipient" },
            { header_name: "Drop off", key: "dropoff" },
            { header_name: "Status", key: "status" },
            { header_name: "Status Date", key: "statusDate" },
            { header_name: "Hours Elapsed", key: "elapsedHrs" },
            { header_name: "Partner", key: "partner" },
            { header_name: "", key: "packageId" },
          ]}
          item={dropoffHistory.filter((x) => x.history === "Present")}
          itemsPerPage={3}
          withLink={false}
          fieldId="packageId"
          actionEvent={(e, row) => {
            setCurrentPackageId(row.packageId);
            allDropoffHistory({
              variables: {
                operatorId:
                  JSON.parse(localStorage.getItem("user")) &&
                  JSON.parse(localStorage.getItem("user")).operator_id,
                dateStart: "2021-01-01",
                dateEnd: new Date().toISOString().split("T")[0],
              },
            })
              .then((data) => {
                if (data.data) {
                  setCurrentPastDropoff(
                    data.data.packageDropoffStatusHistory.filter(
                      (x) =>
                        x.packageId === row.packageId && x.history === "Past"
                    )
                  );
                }
              })
              .catch((e) => console.log(e));
            overlayRef.current.toggle(e);
          }}
        ></TableWithHeader>
      </div>

      <div className="grid ">
        <div className="w-full md:hidden">
          <TotalRecords
            count={dropoffHistory.filter((x) => x.history === "Present").length}
          />

          {dropoffHistory
            .filter((x) => x.history === "Present")
            .map((item, index) => (
              <DropoffHistoryCard key={index} data={item} />
            ))}
        </div>
        {/* generate x cards for every dropoffhistory data*/}
      </div>
      {/* <hr className="my-6"></hr>
        <Button className={"p-2"} value={"Close"} onClick={onClose} /> */}
      {/* <OverlayPanel ref={overlayRef} showCloseIcon>
        <div style={{ height: "50vh", overflowY: "auto" }}>
          <Table
            headers={[
              { header_name: "Locker Name", header_key: "locker" },
              { header_name: "Waybill Number", header_key: "waybill" },
              { header_name: "Recipient", header_key: "recipient" },
              { header_name: "Drop off", header_key: "dropoff" },
              { header_name: "Status", header_key: "status" },
              { header_name: "Status Date", header_key: "statusDate" },
              { header_name: "Hours Elapsed", header_key: "elapsedHrs" },
              { header_name: "Partner", header_key: "partner" },
              { header_name: "History", header_key: "history" },
            ]}
            items={currentPastDropoff}
          />
        </div>
      </OverlayPanel> */}
    </Dialog>
  );
}
